import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

export type ListEnumsResponse = {
  enums: {
    model: string;
    label: string;
  }[];
};

export type UpdateEnumParams = {
  model: string;
  items: unknown[];
};

@Injectable({
  providedIn: 'root'
})
export class EnumsService {
  private enums: Record<string, Promise<unknown[]> | unknown[]> = {};

  async listEnums(): Promise<ListEnumsResponse> {
    const res = await axios.get<ListEnumsResponse>(
      environment.baseUrl + '/api/enum'
    );

    return res.data;
  }

  async getEnum<T = (unknown & { id: unknown })>(model: string): Promise<T[]> {
    if (model in this.enums) {
      return this.enums[model] as Promise<T[]>;
    }

    this.enums[model] = axios.get<T[]>(
      environment.baseUrl + '/api/enum/' + encodeURIComponent(model),
    )
      .then(res => {
        this.enums[model] = res.data;
        return res.data;
      });

    return this.enums[model] as Promise<T[]>;
  }

  async updateSchema(params: UpdateEnumParams): Promise<void> {
    await axios.put(
      environment.baseUrl + '/api/enum/' + encodeURIComponent(params.model),
      params,
    );
    this.enums[params.model] = params.items;
  }
}
